export default __webpack_public_path__ + "static/media/HadoopArchitecture.30c6e1a6.jpg";